// extracted by mini-css-extract-plugin
export default {"wrap":"ModalBack_wrap__cBqMA","background":"ModalBack_background__+TUR+"};